<template>
  <div class="common-pay">
    <el-dialog class="pay-money-dialog" width="535px" :title="titles" :visible.sync="hide"
      :close-on-click-modal="false" :before-close="handleClose" center>
        <div class="orderInfo">
            <div>现金上缴</div>
            <div class="orderPrice"><span>￥</span>{{parmars.amount}}</div>
            <div class="space-between" style="width: 300px;padding-top: 10px; border-top: 1px solid #eee;">
              <div>支付方式</div>
              <div v-if="parmars.payWay == 'yinlianpos'">
                <el-radio v-model="payType" label="SMF">支付码</el-radio>
                <el-radio v-model="payType" label="YHK">银行卡</el-radio>
              </div>
              <div v-else>通联POS机</div>
            </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogconfig">确定支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogHide: true,
      hide: false,
      pay: {},
      orderTitle: '',
      titles: '',
      payType: 'SMF',
      parmars: {}
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init () {
      this.$on('set', function(org) {
				Object.assign(this.$data, this.$options.data());
        
        this.parmars = org;
				if (org.payWay == 'tonglianpos') {
          this.titles = '通联POS机支付';
          this.hide = true;
        } else if (org.payWay == 'yinlianpos') { 
          this.titles = '银联POS机支付';
          this.hide = true;
        }
			})
    },
    handleClose() {
      this.hide = false;
      this.$emit("change", "");
    },
    dialogconfig () {
      console.log(this.parmars);
      if (this.parmars.payWay == 'tonglianpos') {
        this.$emit("change", true);
      } else if (this.parmars.payWay == 'yinlianpos') {
        this.$emit("change", this.payType);
      }
      this.hide = false;
    }
  }
};
</script>

<style lang="less" >
.common-pay {
  .pay-money-dialog {
    .el-dialog {
      top: 50%;
      height: 350px;
      margin-top: -175px !important;
      width: 430px !important;
      min-width: 350px;
      .handleCategroy {
        width: 110px;
        .el-input {
            width: 110px;
        }
        // /deep/ .el-select-dropdown {
        //     width: 100px  !important;
        // }
      }
      .orderInfo {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        font-size: 18px;
        .orderPrice {
            padding: 10px 0;
            font-size: 28px;
        }
      }
      .orderInput {
        text-align: center;
        margin-top: 10px;
        .el-input__suffix {
            line-height: 40px;
        }
      }
      .el-tab-pane {
        text-align: center;
      }
      .smsCode {
        width: 300px;
        text-align: right;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .mobile-number {
          font-size: 12px;
        }
      }
      .el-input {
        width: 300px;
      }
      .el-tabs__nav-scroll {
        .el-tabs__nav {
        //   width: 100%;
          text-align: center;
          .el-tabs__active-bar {
            // left: 108px;
          }
          .el-tabs__item {
            // width: 150px;
            font-size: 16px;
          }
        }
      }
    }
    .el-dialog__body {
        padding: 0 25px 30px;
      .el-tabs {
        margin-top: 20px;
        .el-tabs__nav-wrap {
          &::after {
            height: 0;
          }
        }
      }
    }
    .el-dialog__footer {
      justify-content: center;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      overflow: hidden;
      height: 74px;
      border-top: 0;
      button {
        height: 44px;
        width: 96px;
        font-size: 16px;
      }
      .el-button + .el-button {
        margin-left: 40px;
      }
    }
  }
}
.el-select .el-input .el-select__caret {
    color: #409eff;
    font-weight: 700;
}

</style>